import { ReactElement, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import ModalChangePassword from '../../pages/login/ModalChangePassword';
import { StateRedux } from '../../store/type-redux';
import Dropdown from '../Dropdown';
import User from '../../images/user-empty-profile.png';
import { doRefreshToken } from '../../utils';
import LogoMtrix from '../../images/logo-mtrix-black.png';

interface Props {
  admin?: boolean;
}

const Navbar = ({ admin }: Props): ReactElement => {
  const [showModal, setShowModal] = useState(false);
  // Verifica se é necessário realizar o refresh token
  doRefreshToken.getRefreshToken();

  const { t } = useTranslation();
  const {
    realm: { nameUsuario },
    language: { languageSelected: language },
    keycloak,
  } = useSelector((state: StateRedux) => state);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handlerLogout = () => {
    dispatch({ type: 'LOGOUT' });
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('token');

    keycloak?.clearToken();
    navigate('/login');
  };

  const setLinguage = (languageSelected: string) => {
    dispatch({
      type: 'LANGUAGE',
      language: {
        languageSelected,
      },
    });
  };

  return (
    <>
      <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">
        {admin && (
          <div className="sidebar-brand-icon mr-4">
            <img
              src={LogoMtrix}
              height="40"
              alt="Logo Mtrix"
            />
          </div>
        )}
        <h4 className="mb-0 text-gray-800">
          {t('sidebar.areaDoCliente')}
        </h4>
        <ul className="navbar-nav ml-auto">
          <li className="nav-item dropdown no-arrow">
            <Dropdown
              element={(
                <>
                  <i className="fas fa-globe fa-sm fa-fw mr-2 text-gray-500" />
                  <span className="text-gray-500">{t('navbar.idioma')}</span>
                </>
              )}
              itens={[
                {
                  icon: 'fa-globe',
                  title: t('navbar.portugues'),
                  action: () => setLinguage('pt'),
                  active: language === 'pt',
                },
                {
                  icon: 'fa-globe',
                  title: t('navbar.ingles'),
                  action: () => setLinguage('en'),
                  active: language === 'en',
                }]}
            />
          </li>

          <div className="topbar-divider d-none d-sm-block" />
          <li className="nav-item dropdown no-arrow mx-1">
            <Dropdown
              element={(
                <>
                  <span className="mr-2 d-none d-lg-inline text-gray-600 small">
                    {nameUsuario}
                  </span>
                  <img
                    className="img-profile rounded-circle"
                    alt="user profile"
                    src={User}
                  />
                </>
              )}
              itens={[
                {
                  icon: 'fa-key',
                  title: t('navbar.alterarSenha'),
                  action: () => setShowModal(true),
                },
              ]}
              itemBottom={{
                icon: 'fa-sign-out-alt',
                title: t('navbar.sair'),
                action: handlerLogout,
              }}
            />
          </li>
        </ul>
      </nav>

      <ModalChangePassword
        show={showModal}
        closeModal={() => setShowModal(false)}
      />
    </>
  );
};

Navbar.defaultProps = {
  admin: undefined,
};

export default Navbar;
